import { Component, forwardRef } from "react";
import Loader from "../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { downloadReport, loginUrl, priorityNoActionId, sessionExpireMessage, toastError, toastSuccess, tokenInavlidMessage } from "../../utils/constants";
import Modal from "react-modal";
import { data } from "jquery";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Header from '../../common_components/Header';
import { get_report_list_action } from "../../actions/report_action/report_action";
class ReportList extends Component {
    // intialize constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            panel: null,
            reportList: []
        }
        this.handleChange = this.handleChange.bind(this)
        this.getReportList = this.getReportList.bind(this)
        this.reportNavigate = this.reportNavigate.bind(this)

    }

    componentDidMount() {
        // this.getExhibitionManualForm()
        if (JSON.parse(sessionStorage.getItem('UserLoginData')) == null) {
            console.log('log')
            setTimeout(() => {
                this.props.navigate('/login')
            }, 500);
        }
        this.getReportList()
    }


    handleChange(panel) {
        if (panel == this.state.panel) {
            this.setState({ panel: null })
        }
        else {
            this.setState({ panel: panel })
        }
    }

    getReportList() {
        this.setState({ isLoading: true })
        this.props.get_report_list_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.createReportList(data.data)
                    this.setState({
                    })
                    this.setState({ isLoading: false })
                }
                else {
                    if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                          toast.error(data.msg, {
                            position:"top-center",
                            theme: "colored",
                            autoClose: 3000,
                            hideProgressBar: true,
                          });
                        }, 500);
                    }else{
                    this.setState({ isLoading: false })
                    toastError(data.msg)}
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    createReportList(list) {
        var tempReportGroupList = []
        var tempList = []
        for (var i = 0; i < list.length; i++) {
            if (!tempReportGroupList.includes(list[i].MainReportID)) {
                tempReportGroupList.push(list[i].MainReportID)
                var obj = { MainReportID: list[i].MainReportID, MainReport: list[i].MainReport }
                tempList.push(obj)
            }
        }
        for (var i = 0; i < tempList.length; i++) {
            var tempSubReportList = []
            for (var j = 0; j < list.length; j++) {
                if (tempList[i].MainReportID == list[j].MainReportID) {
                    tempSubReportList.push(list[j])
                }
            }
            tempList[i].subReportList = tempSubReportList
        }
        console.log(tempList)
        setTimeout(() => {
            this.setState({ reportList: tempList })
        }, 100);
    }

    reportNavigate(ReportID, ReportName) {
        if (ReportID == 1) {
            this.props.navigate('/orderReport', { state: { reportID: ReportID, reportName: ReportName } })
        }
        if (ReportID == 2) {
            this.props.navigate('/invoiceReport', { state: { reportID: ReportID, reportName: ReportName } })
        }
        if (ReportID == 3) {
            this.props.navigate('/receiptReport', { state: { reportID: ReportID, reportName: ReportName } })
        }
        if (ReportID == 4) {
            this.props.navigate('/pendingSecurityDepositReport', { state: { reportID: ReportID, reportName: ReportName } })
        }
        if (ReportID == 5) {
            this.props.navigate('/feedbackReport', { state: { reportID: ReportID, reportName: ReportName } })
        }
    }


    render() {
        const { isLoading, panel, reportList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <main id="main">
                    <Header data={[8]} />
                    <section style={{ marginTop: '115px' }}>
                        <div className="container-fluid">
                            <div className="page-header ml-2">
                                <h4 className="page-title">Reports</h4>
                            </div>

                            <div class="col-xl-12 p-0">
                                {reportList.length > 0 && reportList.map((data, i) => (
                                    <Accordion className="m-1" expanded={panel === i} onChange={() => this.handleChange(i)}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                        >
                                            <Typography sx={{ width: '33%', flexShrink: 0 }}>
                                                {data.MainReport}
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                <ul className="" style={{ listStyleType: 'none' }}>
                                                    {data.subReportList.length > 0 && data.subReportList.map((subdata, i) => (
                                                        <li style={{cursor:'pointer'}}
                                                            onClick={() => this.reportNavigate(subdata.ReportID, subdata.MainReport)}
                                                            class="mb-1">
                                                            <a>{`${i + 1})`} {subdata.SubReport}</a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                                {/* <Accordion className="m-1" expanded={panel === 1} onChange={() => this.handleChange(1)}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <Typography sx={{ width: '33%', flexShrink: 0 }}>
                                    General settings
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <ul>
                                        <li class="mb-1">
                                            <a href="#">1) 111 Anim pariatur cliche reprehenderit, enim eiusmod high life.</a>
                                        </li>
                                        <li class="mb-1">
                                            <a href="#">2)  You can modify any of this with custom CSS or overriding our default variables. It's also worth</a>
                                        </li>
                                        <li class="mb-1">
                                            <a href="#">3) HTML can go within the .accordion-body, though the transition does limit overflow.</a>
                                        </li>
                                    </ul>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className="m-1" expanded={panel === 2} onChange={() => this.handleChange(2)}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2bh-content"
                                id="panel2bh-header"
                            >
                                <Typography sx={{ width: '33%', flexShrink: 0 }}>Users</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Donec placerat, lectus sed mattis semper, neque lectus feugiat lectus,
                                    varius pulvinar diam eros in elit. Pellentesque convallis laoreet
                                    laoreet.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className="m-1" expanded={panel === 3} onChange={() => this.handleChange(3)}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3bh-content"
                                id="panel3bh-header"
                            >
                                <Typography sx={{ width: '33%', flexShrink: 0 }}>
                                    Advanced settings
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                    amet egestas eros, vitae egestas augue. Duis vel est augue.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className="m-1" expanded={panel === 4} onChange={() => this.handleChange(4)}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel4bh-content"
                                id="panel4bh-header"
                            >
                                <Typography sx={{ width: '33%', flexShrink: 0 }}>Personal data</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                    amet egestas eros, vitae egestas augue. Duis vel est augue.
                                </Typography>
                            </AccordionDetails>
                        </Accordion> */}
                            </div>
                            {/* </div> */}
                        </div>
                    </section>
                </main >
            </>
        )
    }
}

export default withRouter(connect(null, { get_report_list_action })(ReportList))